import { render } from "./nfs.vue?vue&type=template&id=d66ff264"
import script from "./nfs.vue?vue&type=script&lang=js"
export * from "./nfs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__